/**
 * @readonly
 * @enum {string}
 */
export const TpmsIssueTypes = Object.freeze({
    AXLE_PRESSURE_DIFFERENCE: 'AXLE_PRESSURE_DIFFERENCE',
    AXLE_TEMPERATURE_DIFFERENCE: 'AXLE_TEMPERATURE_DIFFERENCE',
    DEMOUNTED_SENSOR: 'DEMOUNTED_SENSOR',
    DETACHED_SENSOR: 'DETACHED_SENSOR',
    DUAL_WHEEL_PRESSURE_DIFFERENCE: 'DUAL_WHEEL_PRESSURE_DIFFERENCE',
    FAULTY_SIGNAL_PRESSURE: 'FAULTY_SIGNAL_PRESSURE',
    FAULTY_SIGNAL_TEMPERATURE: 'FAULTY_SIGNAL_TEMPERATURE',
    HIGH_LOAD: 'HIGH_LOAD',
    HIGH_PRESSURE: 'HIGH_PRESSURE',
    HIGH_TEMPERATURE: 'HIGH_TEMPERATURE',
    LOSING_PRESSURE: 'LOSING_PRESSURE',
    LOW_BATTERY: 'LOW_BATTERY',
    LOW_BATTERY_LEVEL: 'LOW_BATTERY_LEVEL',
    LOW_PRESSURE: 'LOW_PRESSURE',
    LOW_TREAD_DEPTH: 'LOW_TREAD_DEPTH',
    MISSING_SENSOR: 'MISSING_SENSOR',
    MISSING_SENSOR_EXTERNAL: 'MISSING_SENSOR_EXTERNAL',
    NOT_PROGRAMMED_SENSOR: 'NOT_PROGRAMMED_SENSOR'
})
